import React from 'react';
import './NavBar.css';

const NavBarItem = ({ title }) => (
	<li className="nav-item">
		<a className="customLink nav-link js-scroll-trigger" href={'#' + title}>
			{title}
		</a>
	</li>
);

export default NavBarItem;
